import React, { FC } from 'react';
import DateTimePicker from 'react-datetime-picker';

import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';

import styles from './index.module.scss';

interface TimePeriodProps {
  attrs: any;
  value: any;
  onChange: any;
  className: any;
  disabled: boolean;
}

const TimePeriod: FC<TimePeriodProps> = ({
  attrs,
  value,
  onChange,
  className,
  disabled,
}) => {
  return (
    <div className={`${styles.container} ${className}`}>
      <DateTimePicker
        className={styles.dateInput}
        onChange={startValue => onChange([startValue, value[1]])}
        value={value[0]}
        disabled={disabled}
        calendarIcon={null}
        disableCalendar
        format='HH:mm'
        shouldOpenWidgets={({ reason, widget }) => {
          return false;
        }}
        {...attrs.startTime}
      />
      <div className={styles.separator}>{'-'}</div>
      <DateTimePicker
        className={styles.dateInput}
        onChange={endValue => onChange([value[0], endValue])}
        value={value[1]}
        disabled={disabled}
        calendarIcon={null}
        disableCalendar
        format='HH:mm'
        shouldOpenWidgets={({ reason, widget }) => {
          return false;
        }}
        {...attrs.endTime}
      />
    </div>
  );
};

export default TimePeriod;
